const PARTNERS = [
  "Schwarzkopf Professional",
  "Moroccan Oil",
  "Design.Me",
  "K18 Peptide",
  "Kerastase",
  "Fiber Plex",
  "Remy Extensions",
];

export default function Marquee() {
  // Duplicate for seamless loop
  const items = [...PARTNERS, ...PARTNERS];

  return (
    <section
      data-testid="partners-marquee"
      className="relative bg-sand-100 border-y border-black/5 py-10 overflow-hidden"
    >
      <div className="marquee-track">
        {items.map((p, i) => (
          <div
            key={`${p}-${i}`}
            className="flex items-center gap-16 px-8 font-serif text-3xl lg:text-4xl text-ink-900 italic font-light whitespace-nowrap"
          >
            <span>{p}</span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
